import React from 'react'

function Beauty() {
  return (
    <div>Beauty</div>
  )
}

export default Beauty